import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import dayjs from 'dayjs'
import { Tooltip, makeStyles } from '@material-ui/core'
import { isPublished } from './utils'

const useStyles = makeStyles({
  chip: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    width: '100%',
    minWidth: 0,
    backgroundColor: '#ebeff5',
    borderRadius: 6,
    padding: '2px 8px',
    border: 'none',
    textAlign: 'left',
    font: 'inherit',
  },
  clickable: {
    cursor: 'pointer',
    '&:hover': { backgroundColor: '#e0e6f0' },
  },
  dot: { width: 8, height: 8, borderRadius: '50%', flexShrink: 0 },
  published: { backgroundColor: '#008e5b' },
  draft: { backgroundColor: '#7f889c' },
  name: {
    fontSize: 12,
    fontWeight: 600,
    color: '#0d0d0d',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
})

const timeRange = (event) =>
  `${dayjs(event.startAt).format('MMM D, h:mm A')} – ${dayjs(event.endAt).format('MMM D, h:mm A')}`

const EventChip = ({ event, onClick }) => {
  const styles = useStyles()
  const content = (
    <>
      <span className={clsx(styles.dot, isPublished(event.status) ? styles.published : styles.draft)} />
      <span className={styles.name}>{event.name}</span>
    </>
  )
  return (
    <Tooltip title={timeRange(event)}>
      {onClick ? (
        <button type="button" className={clsx(styles.chip, styles.clickable)} onClick={() => onClick(event)}>
          {content}
        </button>
      ) : (
        <div className={styles.chip}>{content}</div>
      )}
    </Tooltip>
  )
}

EventChip.propTypes = {
  event: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    startAt: PropTypes.string.isRequired,
    endAt: PropTypes.string.isRequired,
  }).isRequired,
  onClick: PropTypes.func,
}

EventChip.defaultProps = {
  onClick: undefined,
}

export default EventChip
